

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Breadcrumbs extends Vue {
  private currentItemKey: number = 0;

  get items() {
    return this.$route.meta.breadcrumbs || [];
  }

  private trucatedText(text: string, length: number) {
    return text && text.length > length ? text.substring(0, length) + '...' : text;
  }

  private navigateToPath(item: any) {
    this.$router.push({
      path: item.path,
    });
  }

  private mounted() {
    this.$events.on('update-breadcrumbs', (data: any) => {
      this.items.forEach((item: any) => {
        if (item.params) {
          item.params.id = this.$route.params.id;
          item.params.mrid = this.$route.params.mrid;
          if (item.params.mrid && item.params.resid) {
            item.params.resid = this.$route.params.resid;
            item.path = `${item.navigateToPath}` + `/${item.params.id}` + `/${item.params.mrid}` + `/${item.params.resid}`;
          } else if (item.params.mrid && !item.params.resid) {
            item.path = `${item.navigateToPath}` + `/${item.params.id}` + `/${item.params.mrid}`;
          } else if (item.params.id && item.params.resid) {
            item.params.resid = this.$route.params.resid;
            item.path = `${item.navigateToPath}` + `/${item.params.id}` + `/${item.params.resid}`;
          } else if (item.params.id) {
            item.path = `${item.navigateToPath}` + `/${item.params.id}`
          }
        }
        if (data && item.title) {
          item.text = data.title;
        }
      });
      this.currentItemKey += 1;
    });
  }
}
